// src/components/events/EventDetail/EventDetailActions.tsx
// Event 詳情操作按鈕：Delete

import React from 'react';
import { Trash2 } from '../../../../components/common/icons';

interface EventDetailActionsProps {
  onDelete: () => void;
  isSubmitting?: boolean;
}

export const EventDetailActions: React.FC<EventDetailActionsProps> = ({
  onDelete,
  isSubmitting = false,
}) => {
  return (
    <div className="flex gap-2">
      <button
        onClick={onDelete}
        disabled={isSubmitting}
        className="px-4 py-2.5 border border-gray-300 rounded-lg text-gray-500 hover:text-red-600 hover:border-red-300 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        title="Delete Event"
        aria-label="Delete Event"
      >
        <Trash2 size={18} />
      </button>
    </div>
  );
};
